import { PipeTransform, Pipe } from '@angular/core';
import { MerchantHierarchyModel} from "@app/models/customer-transaction-history/Transaction-Filter-model";
import { SearchMerchant } from "@app/models/merchant/SearchMerchant";

@Pipe({
    name: 'merchantnamefilter'
})
export class MerchantNamePipe implements PipeTransform {
    transform(items: SearchMerchant[], searchTerm: string): SearchMerchant[] {
        if (!items || !searchTerm) {
            return items;
        }
        return items.filter(item =>
            (item.Name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
            );
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/merchantNameFilter.pipe.ts